export default  {
	"result": {
		"position": {
			"width": 95,
			"top": 97,
			"height": 95,
			"left": 175
		},
		"liveness": {
			"real": 99,
			"fake": 0
		},
		"result": true
	},
	"error_code": 0,
	"description": "检测成功",
	"request_id": "02AD995CC5444C4F8E9992978C043501",
	"recognize_time": 27,
	"available_count": 9998,
	"version": null
}


//////////////////
// WEBPACK FOOTER
// ./static/preview_data/v3_liveness.js
// module id = null
// module chunks = 